// react
import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import {Provider} from "mobx-react"
//import ReactGA from 'react-ga';

// local
import './App.css';
import "./components/components.css";
import "./pages/pages.css";
import {defaultClient, Client, defaultUser, User, System, defaultSystem} from "./types";
import {EngagementsPage, ForgotPassword, LoginPage, ReportsPage, SitesPage} from './pages';
import {Loading} from "./components";

//ReactGA.initialize(GOOGLE_TRACKING_ID);

// freshdesk
// See: https://github.com/arjunkomath/node-freshdesk-api

window.Buffer = window.Buffer || require("buffer").Buffer;
export const Freshdesk = require("freshdesk-api");
export const frApi = new Freshdesk("https://blunovus.freshdesk.com", "ljgL61qbzcvkhFAYk5bv");

/**
 * App
 */

interface IAppProps {
}

interface IAppState {
    loaded: boolean,
    system: System,
    user: User,
    client: Client
}

class App extends React.Component<IAppProps, IAppState> {

    constructor(props: IAppProps) {
        super(props);

        // Initialize the mobx globals.
        this.state = {
            loaded: false,
            system: defaultSystem,
            user: defaultUser,
            client: defaultClient
        }
    }

    componentDidMount = async () => {
        // setup
        const {system, client} = this.state;

        // Get the client list and possibly client info.
        await system.initialize();
        await client.initialize();
        this.setState({loaded: true});
    }

    render() {
        // setup
        const {system, user, client, loaded} = this.state;

        // render
        if (!loaded) {
            return <Loading/>
        }
        return (
            <div
                className="App"
            >
                <Provider
                    system={system}
                    user={user}
                    client={client}
                >
                    <Routes>
                        <Route path="/" element={<Navigate to="/login" />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/forgotpassword" element={<ForgotPassword />} />
                        <Route path="/reports" element={<ReportsPage />} />
                        <Route path="/sites" element={<SitesPage />} />
                        <Route path="/engagements" element={<EngagementsPage />} />
                    </Routes>
                </Provider>
            </div>
        )
    }
}

export default App;
